import { HardHat, Loader2 } from "lucide-react";

export default function AuthenticatedLoading() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
        <HardHat className="h-8 w-8 text-primary" />
      </div>
      <Loader2 className="mt-4 h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
